import { useApolloClient } from "@apollo/client";
import { queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import { extractFQDN } from "@bluframe/mightychroma-mightytool-ui";
import { useCallback } from "react";
const { vendors: { SEARCH_LABELS_BY_URL } } = queries;
/**
 * useInferLabelCreditByUrl
 *
 * @description Returns a callback that resolves a single matching label vendor
 * name from a URL/FQDN host, to prefill screenshot credit.
 * @returns {(urlOrFqdn: string) => Promise<string | undefined>}
 *
 */
const useInferLabelCreditByUrl = () => {
    const apolloClient = useApolloClient();
    return useCallback(async (url) => {
        const normalizedUrl = url.trim();
        const fqdn = extractFQDN(normalizedUrl);
        if (!fqdn) {
            return undefined;
        }
        try {
            const { data } = await apolloClient.query({
                fetchPolicy: "network-only",
                query: SEARCH_LABELS_BY_URL,
                variables: {
                    searchLabelsByUrlInput: {
                        url: fqdn
                    }
                }
            });
            const labels = data?.searchLabelsByUrl ?? [];
            return labels.length === 1 ? labels[0]?.vendor.name : undefined;
        }
        catch (_error) {
            return undefined;
        }
    }, [apolloClient]);
};
export default useInferLabelCreditByUrl;
